import { BlockTypes, type StoryblokRichTextNode } from '@storyblok/richtext';

export const EMPTY_RICHTEXT: StoryblokRichTextNode = { type: BlockTypes.DOCUMENT, content: [] };
